/**
 * @generated SignedSource<<a56aaf62e03d0f4bfd42e5aa14827ccf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EpicLinkCell$data = {
  readonly epic: {
    readonly color: string | null | undefined;
    readonly key: string | null | undefined;
    readonly summary: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "EpicLinkCell";
};
export type EpicLinkCell$key = {
  readonly " $data"?: EpicLinkCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"EpicLinkCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "EpicLinkCell",
  "selections": [
    {
      "concreteType": "JiraEpic",
      "kind": "LinkedField",
      "name": "epic",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "kind": "ScalarField",
          "name": "summary"
        },
        {
          "kind": "ScalarField",
          "name": "color"
        }
      ]
    }
  ],
  "type": "JiraEpicLinkField"
};

(node as any).hash = "cbc046611b6b7cab39bbe7c2ae02d46d";

export default node;
